<template>
  <div>
    <Bookings v-if="isAdmin"/>
  </div>
</template> 

<script>
import Bookings from "@/components/bookings/admin/bookings";
export default {
  name: 'AdminBookings',
  components: { Bookings },
  data() {
    return {}
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>